import { render, staticRenderFns } from "./viewBrands.vue?vue&type=template&id=c867d1c6&"
import script from "./viewBrands.vue?vue&type=script&lang=js&"
export * from "./viewBrands.vue?vue&type=script&lang=js&"
import style0 from "./viewBrands.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports